import * as tslib_1 from "tslib";
import { NgZone } from '@angular/core';
import { InterfaceService } from '@app/interfaces';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Subject } from "rxjs/internal/Subject";
import { map, tap } from 'rxjs/operators';
import { BsModalRef } from "ngx-bootstrap";
import { JobHoldAbortFocComponent } from "@app/shared/cs-components/common-jobs/job-hold-abort-foc/job-hold-abort-foc.component";
import { JobFocAndAbortComponent } from "@app/shared/cs-components/common-jobs/free-of-charge-and-abort/job-foc-and-abort.component";
import { SidepanelModalService } from "@app/sidepanel/services/sidepanel-modal.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { JobSidebarService } from "@app/job-sidebar/job-sidebar-service";
import { TimelineService } from '@app/shared/services/timeline.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../../../sidepanel/services/sidepanel-modal.service";
import * as i3 from "ngx-bootstrap/modal";
import * as i4 from "@angular/router";
import * as i5 from "@ngx-translate/core";
import * as i6 from "../../../../../job-sidebar/job-sidebar-service";
import * as i7 from "../../../../../shared/services/timeline.service";
var JobViewService = /** @class */ (function (_super) {
    tslib_1.__extends(JobViewService, _super);
    function JobViewService(http, modalService, bsModalRef, router, translate, ngZone, jobSidebarService, timelineService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.modalService = modalService;
        _this.bsModalRef = bsModalRef;
        _this.router = router;
        _this.translate = translate;
        _this.ngZone = ngZone;
        _this.jobSidebarService = jobSidebarService;
        _this.timelineService = timelineService;
        _this.jobReasonsData = [];
        _this.timelineTriggerEvent = new Subject();
        _this.timelineTriggerEvent$ = _this.timelineTriggerEvent.asObservable();
        _this.recallDetails = new Subject();
        _this.recallDetails$ = _this.recallDetails.asObservable();
        _this.removeOnHoldConfirm = function (arg, cb) {
            var removejobonhold = {
                removejobonhold: {
                    id: _this.jobReasonsData['jobId']
                }
            };
            _this.removeOnHold(removejobonhold).subscribe(function (res) {
                cb();
                _this.ngZone.run(function () { return _this.timelineTriggerFunction(res); });
                var jid = _this.jobReasonsData['jobId'];
                if (jid != null) {
                    _this.jobSidebarService.notifyJobDetailsRefresh(jid);
                }
            }, function (err) {
                cb();
            });
        };
        _this.confirmModalConfig = {
            showModal: false,
            modalType: 'confirm',
            title: 'Remove on hold',
            actionText: 'remove',
            itemText: 'on-hold status from this job',
            confirmBtnText: 'Remove',
            confirmBtnType: 'DELETE',
            confirmBxValidationMsg: 'You need to type the word \'REMOVE\' to remove the on-hold',
            defaultTextMessage: true,
            message: {
                warningTxt: 'By removing job from the on-hold status you understand the job will appear as a normal outstanding job and will need further action i.e. rebook/invoicing etc.',
            },
            doAction: _this.removeOnHoldConfirm
        };
        _this.deleteJobConfirm = function (arg, cb) {
            var deleteJob = {
                job: {
                    id: _this.jobReasonsData['jobId']
                }
            };
            _this.deleteJob(deleteJob).subscribe(function (res) {
                cb();
                _this.timelineTriggerFunction(res);
                _this.router.navigateByUrl('/customers/' + _this.jobReasonsData['customerType'] + '/' + _this.jobReasonsData['customerId'] + '/view_v2/property/view');
            }, function (err) {
                cb();
                _this.timelineTriggerFunction('res');
                _this.router.navigateByUrl('/customers/' + _this.jobReasonsData['customerType'] + '/' + _this.jobReasonsData['customerId'] + '/view_v2/property/view');
            });
        };
        _this.deleteConfirmModalConfig = {
            showModal: false,
            modalType: 'confirm',
            title: 'Delete job',
            actionText: 'delete',
            confirmBtnText: 'delete',
            closeText: 'Close',
            confirmBtnType: 'DELETE',
            itemText: 'job',
            confirmBxValidationMsg: 'You need to type the word \'DELETE\' to remove the job',
            defaultTextMessage: false,
            message: {
                warningTxt: 'To confirm you wish to delete this job, please type DELETE in the box below and click delete.',
            },
            doAction: _this.deleteJobConfirm,
        };
        _this.getJobViewDetails = function (id, type, jobId) {
            return this.http.get(this.getJobApiUrl("customers/" + type + "/" + id + "/jobs/" + jobId + "/view"));
        };
        _this.getJobCertificates = function (id, type, jobId) {
            return this.http.get(this.getJobApiUrl("customers/" + type + "/" + id + "/job/" + jobId + "/certificates/view"));
        };
        _this.saveOnHold = function (type, id, jobId, data) {
            return this.http.post(this.getApiUrl("customers/" + type + "/" + id + "/jobs/" + jobId + "/place_on_hold"), data);
        };
        _this.removeOnHold = function (jobData) {
            return this.http.post(this.getApiUrl("remove_job_on_hold"), jobData);
        };
        _this.freeOfCharge = function (type, id, jobId, data) {
            return this.http.post(this.getApiUrl("customers/" + type + "/" + id + "/jobs/" + jobId + "/free_of_charge_job"), data);
        };
        _this.abortJob = function (type, id, jobId, data) {
            return this.http.post(this.getApiUrl("customers/" + type + "/" + id + "/jobs/" + jobId + "/new_abort_job"), data);
        };
        _this.deleteJob = function (data) {
            return this.http.post(this.getApiUrl("delete_job"), data);
        };
        _this.getJobOpportunities = function (id, jobId, param) {
            var url = this.getJobApiUrl("customers/customer/" + id + "/job/" + jobId + "/opportunities/view");
            return this.http.post(url, param);
        };
        _this.getJobOpportunitiesStage = function (id, jobId) {
            var formData = new FormData();
            formData.append("id", id);
            formData.append("jobId", jobId);
            var url = this.getJobApiUrl("getJobOpportunityStages");
            return this.http.post(url, formData);
        };
        _this.getAttachmentTags = function () {
            var url = this.getJobApiUrl('/e5ec7051/fileList');
            return this.http.post(url, '');
        };
        _this.getInvoiceWipList = function (customerId, jobId, customerType, param, selectedType) {
            if (selectedType === void 0) { selectedType = ''; }
            var url = this.getJobApiUrl(("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/invoices/wip/" + selectedType + "/view"));
            return this.http.post(url, param);
        };
        _this.remove_invoice_items = function (param) {
            var _this = this;
            return this.http.post(this.getJobApiUrl("remove_invoice_items"), param).pipe(tap(function () { return _this.triggerFinanceRefresh(_this.getJobIdFromFormDataOrObject(param)); }));
        };
        _this.delete_part = function (param) {
            var _this = this;
            return this.http.post(this.getJobApiUrl("delete_part"), param).pipe(tap(function () { return _this.triggerFinanceRefresh(_this.getJobIdFromFormDataOrObject(param)); }));
        };
        _this.delete_supplier_invoice = function (id, invoiceId, param) {
            var _this = this;
            var url = this.getApiUrl(("suppliers/" + id + "/invoice/" + invoiceId + "/delete"));
            return this.http.post(url, param).pipe(tap(function () { return _this.triggerFinanceRefresh(_this.getJobIdFromFormDataOrObject(param)); }));
        };
        _this.delete_credit_note = function (id, invoiceId, param) {
            var _this = this;
            var url = this.getApiUrl(("suppliers/delete_credit_note"));
            return this.http.post(url, param).pipe(tap(function () { return _this.triggerFinanceRefresh(_this.getJobIdFromFormDataOrObject(param)); }));
        };
        _this.markCreditNoteNotRequired = function (param) {
            var _this = this;
            return this.http.post(this.getApiUrl("mark_credit_note_not_required"), param).pipe(tap(function () { return _this.triggerFinanceRefresh(_this.getJobIdFromFormDataOrObject(param)); }));
        };
        _this.getCostScheduledLabourList = function (customerId, jobId, customerType, param) {
            var url = this.getJobApiUrl(("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/costs/forecasted/scheduled_labour"));
            if (param['download'] == 'download_xl') {
                return this.http.post(url, param, { responseType: 'blob' });
            }
            else {
                return this.http.post(url, param);
            }
        };
        _this.getCostRequestedPartsList = function (customerId, jobId, customerType, param) {
            var url = this.getJobApiUrl(("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/costs/forecasted/requested_parts"));
            if (param['download'] == 'download_xl') {
                return this.http.post(url, param, { responseType: 'blob' });
            }
            else {
                return this.http.post(url, param);
            }
        };
        _this.getCostMaterialsInstalledList = function (customerId, jobId, customerType, param) {
            var url = this.getJobApiUrl(("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/costs/actual_cost/parts"));
            if (param['download'] == 'download_xl') {
                return this.http.post(url, param, { responseType: 'blob' });
            }
            else {
                return this.http.post(url, param);
            }
        };
        _this.getCostCreditNotesList = function (customerId, jobId, customerType, param) {
            var url = this.getJobApiUrl(("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/costs/actual_cost/credit_notes"));
            if (param['download'] == 'download_xl') {
                return this.http.post(url, param, { responseType: 'blob' });
            }
            else {
                return this.http.post(url, param);
            }
        };
        _this.getCostPartsReturnsList = function (customerId, jobId, customerType, param) {
            var url = this.getJobApiUrl(("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/costs/actual_cost/parts_returns"));
            if (param['download'] == 'download_xl') {
                return this.http.post(url, param, { responseType: 'blob' });
            }
            else {
                return this.http.post(url, param);
            }
        };
        _this.getCostPurchaseOrderList = function (customerId, jobId, customerType, param) {
            var url = this.getJobApiUrl(("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/costs/forecasted/purchase_orders"));
            if (param['download'] == 'download_xl') {
                return this.http.post(url, param, { responseType: 'blob' });
            }
            else {
                return this.http.post(url, param);
            }
        };
        _this.getCostSupplierInvoiceList = function (customerId, jobId, customerType, param) {
            var url = this.getJobApiUrl(("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/costs/actual_cost/supplier_invoices"));
            if (param['download'] == 'download_xl') {
                return this.http.post(url, param, { responseType: 'blob' });
            }
            else {
                return this.http.post(url, param);
            }
        };
        _this.getUnApprovedLabourList = function (customerId, jobId, customerType, param) {
            var url = this.getJobApiUrl(("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/costs/forecasted/unapproved_labour"));
            if (param['download'] == 'download_xl') {
                return this.http.post(url, param, { responseType: 'blob' });
            }
            else {
                return this.http.post(url, param);
            }
        };
        _this.getApprovedLabourList = function (customerId, jobId, customerType, param) {
            var url = this.getJobApiUrl(("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/costs/actual_cost/labour"));
            if (param['download'] == 'download_xl') {
                return this.http.post(url, param, { responseType: 'blob' });
            }
            else {
                return this.http.post(url, param);
            }
        };
        _this.getApprovedTravelList = function (customerId, jobId, customerType, param) {
            var url = this.getJobApiUrl(("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/costs/actual_cost/travel"));
            if (param['download'] == 'download_xl') {
                return this.http.post(url, param, { responseType: 'blob' });
            }
            else {
                return this.http.post(url, param);
            }
        };
        _this.getApprovedPerDiemList = function (customerId, jobId, customerType, param) {
            var url = this.getJobApiUrl(("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/costs/actual_cost/per_diem"));
            if (param['download'] == 'download_xl') {
                return this.http.post(url, param, { responseType: 'blob' });
            }
            else {
                return this.http.post(url, param);
            }
        };
        _this.getTagList = function () {
            var url = this.getApiUrl("tags/list?page=1&limit=100");
            return this.http.get(url);
        };
        return _this;
    }
    JobViewService.prototype.setJobReasonsData = function (data) {
        this.jobReasonsData = data;
    };
    JobViewService.prototype.getRemoveOnHoldData = function () {
        return this.confirmModalConfig;
    };
    JobViewService.prototype.getDeleteConfirmModalData = function () {
        return this.deleteConfirmModalConfig;
    };
    JobViewService.prototype.triggerFinanceRefresh = function (jobId) {
        if (jobId != null && !isNaN(jobId)) {
            this.jobSidebarService.notifyJobFinanceRefresh(jobId);
        }
    };
    /** Row / save payloads may use jobId or jobid; missing id skips finance refresh. */
    JobViewService.prototype.getJobIdFromPartPayload = function (payload) {
        if (!payload) {
            return undefined;
        }
        var raw = payload.jobId != null ? payload.jobId : payload.jobid;
        if (raw === undefined || raw === null || raw === '') {
            return undefined;
        }
        var n = Number(raw);
        return !isNaN(n) ? n : undefined;
    };
    /** delete_part / remove_invoice_items / cost deletes often use FormData with jobId. */
    JobViewService.prototype.getJobIdFromFormDataOrObject = function (payload) {
        if (!payload) {
            return undefined;
        }
        if (typeof FormData !== 'undefined' && payload instanceof FormData) {
            var v = payload.get('jobId') || payload.get('jobid');
            if (v == null || v === '' || typeof v !== 'string') {
                return undefined;
            }
            var n = Number(v);
            return !isNaN(n) ? n : undefined;
        }
        return this.getJobIdFromPartPayload(payload);
    };
    JobViewService.prototype.getTimelineViewDetails = function (customerId, jobId) {
        var url = this.getApiUrl("timelineViewDetails/" + customerId + "?tableType=31&id=" + jobId);
        return this.http.get(url);
    };
    JobViewService.prototype.deleteAttachFiles = function (attachfile) {
        return this.http.post(this.getApiUrl("delete_job_files"), attachfile);
    };
    JobViewService.prototype.getDairyList = function (customerId, jobId, customerType, param) {
        var url = this.getJobApiUrl("customers/" + customerType + "/" + customerId + "/jobs/" + jobId + "/diaryevents");
        if (param['download'] == 'download_xl') {
            return this.http.post(url, param, { responseType: 'blob' });
        }
        else {
            return this.http.post(url, param);
        }
    };
    JobViewService.prototype.getCertificateList = function (customerId, jobId, param) {
        var url = this.getJobApiUrl(("customers/customer/" + customerId + "/job/" + jobId + "/certificates/view"));
        //return this.http.post(url, param);
        var certiData = this.http.post(url, param).pipe(map(function (response) {
            return {
                data: response.data || [],
                count: response.count || 0,
                addOnData: { totalCount: response.count || 0, params: param }
            };
        }));
        return certiData;
    };
    JobViewService.prototype.deleteCertificate = function (id) {
        var formData = new FormData();
        formData.append("id", id);
        var url = this.getJobApiUrl(("delete_job_certificate"));
        return this.http.post(url, formData);
    };
    JobViewService.prototype.getJDArriveLeaveTemplatesList = function (type, jobDescriptionId) {
        return this.http.get(this.getJobApiUrl("getJDArriveLeaveTemplatesList/" + jobDescriptionId + "/" + type));
    };
    JobViewService.prototype.deleteDairy = function (id) {
        return this.http.delete(this.getApiUrl("delete_diary_event/" + id));
    };
    JobViewService.prototype.getCreatedByTypeTemplatesList = function () {
        return this.http.get(this.getJobApiUrl("getCreatedByTypeList"));
    };
    JobViewService.prototype.updateFile = function (id, data) {
        return this.http.post(this.getJobApiUrl('e5ec7051/renameFile'), data);
    };
    JobViewService.prototype.getFileList = function (customerId, jobId, param) {
        // let url = this.getV5CoreApiUrl(`customers/customer/${customerId}/jobs/${jobId}/files/view`);
        var url = this.getJobApiUrl('e5ec7051/fileList');
        // const fileData = this.http.post<any>(url, param).pipe(
        //     map(response => {
        //         return {
        //             data: response.attached_files.data || [],
        //             customerPortalAccess: response.attached_files.customerPortalAccess ,
        //             count: response.count || 0,
        //             addOnData: { tags : response.attached_files.tags, filesCount: response.count || 0, params: param}
        //         };
        //     })
        // );
        var fileData = this.http.post(url, param).pipe(map(function (response) {
            return {
                data: (response.attached_files.data || []).map(function (item) { return (tslib_1.__assign({}, item, { customerPortalAccess: response.attached_files.customerPortalAccess, customerPortalVisibilityStatus: response.attached_files.visibilityStatus })); }),
                customerPortalAccess: response.attached_files.customerPortalAccess,
                customerPortalVisibilityStatus: response.attached_files.visibilityStatus,
                jobFileAddStatus: response.attached_files.jobFileAddStatus,
                count: response.count || 0,
                addOnData: {
                    tags: response.attached_files.tags,
                    filesCount: response.count || 0,
                    params: param
                }
            };
        }));
        return fileData;
    };
    JobViewService.prototype.deleteJobFile = function (params) {
        return this.http.post(this.getJobApiUrl("e5ec7051/deleteAttachedFile"), params, {
            responseType: 'text'
        });
    };
    JobViewService.prototype.downloadJobFilesZip = function (customerType, customerId, jobId, fileIds) {
        var url = this.getJobApiUrl("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/files/download-zip");
        var body = fileIds && fileIds.length > 0 ? { fileIds: fileIds } : {};
        return this.http.post(url, body, { responseType: 'blob' });
    };
    /** Download a single file via backend – file downloads instead of opening in browser. Backend expects fileIds array. */
    JobViewService.prototype.downloadJobFile = function (customerType, customerId, jobId, fileId) {
        var url = this.getJobApiUrl("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/files/download");
        return this.http.post(url, { fileIds: [fileId] }, { responseType: 'blob' });
    };
    JobViewService.prototype.openSidePanel = function (type) {
        var _this = this;
        var title = (type == 'foc') ? 'Free of charge this job' : 'Abort this job';
        var reasons = this.jobReasonsData[type];
        var label = (type == 'foc') ? 'Free of charge reason' : 'Abort reason';
        var initialState = {
            title: title,
            reasons: reasons,
            labelType: label,
        };
        this.bsModalRef = this.modalService.show(JobFocAndAbortComponent, {
            initialState: initialState
        });
        this.bsModalRef.content.onClose.subscribe(function (result) {
            if (result) {
                var payload = {
                    freeofchargeandabortjob: {
                        reason: result['reason'],
                        moredetails: result['note'],
                        JobView: false
                    }
                };
                if (type == 'foc') {
                    _this.freeOfCharge(_this.jobReasonsData['customerType'], _this.jobReasonsData['customerId'], _this.jobReasonsData['jobId'], payload).subscribe(function (resp) {
                        _this.timelineTriggerFunction(resp);
                        var jobId = _this.jobReasonsData['jobId'];
                        if (jobId != null) {
                            _this.jobSidebarService.notifyJobDetailsRefresh(jobId);
                        }
                    }, function (error) {
                        console.log('err', error);
                    });
                }
                else {
                    _this.abortJob(_this.jobReasonsData['customerType'], _this.jobReasonsData['customerId'], _this.jobReasonsData['jobId'], payload).subscribe(function (resp) {
                        _this.timelineTriggerFunction(resp);
                        var jobId = _this.jobReasonsData['jobId'];
                        if (jobId != null) {
                            _this.jobSidebarService.notifyJobDetailsRefresh(jobId);
                        }
                    }, function (error) {
                        console.log('err', error);
                    });
                }
            }
        });
    };
    JobViewService.prototype.timelineTriggerFunction = function (res) {
        this.timelineTriggerEvent.next(res);
    };
    JobViewService.prototype.jobStatusChange = function (type) {
        var _this = this;
        var initialState = {
            title: 'Put job on hold',
            reasons: this.jobReasonsData[type],
            labelType: this.translate.instant('On.Hold.Description'),
            users: this.jobReasonsData['users'],
        };
        this.bsModalRef = this.modalService.show(JobHoldAbortFocComponent, {
            initialState: initialState
        });
        this.bsModalRef.content.onClose.subscribe(function (result) {
            if (result) {
                var payload = {
                    onholdjob: {
                        settingsjobonholddescriptionid: result['reason'],
                        onholdjobusers: { onholdjobusers: '' },
                        jobView: false
                    }
                };
                _this.saveOnHoldTrigger(payload);
            }
        });
    };
    JobViewService.prototype.saveOnHoldTrigger = function (payload) {
        var _this = this;
        var jobId = this.jobReasonsData['jobId'];
        this.saveOnHold(this.jobReasonsData['customerType'], this.jobReasonsData['customerId'], jobId, payload)
            .subscribe(function (resp) {
            _this.ngZone.run(function () { return _this.timelineTriggerFunction(resp); });
            if (jobId != null) {
                _this.jobSidebarService.notifyJobDetailsRefresh(jobId);
            }
        }, function (error) {
            console.log('err', error);
        });
    };
    JobViewService.prototype.getJobOpportunitiesProposal = function (id, jobId) {
        var url = this.getJobApiUrl("customers/customer/" + id + "/job/" + jobId + "/opportunities/proposal");
        return this.http.post(url, '');
    };
    JobViewService.prototype.checkClientDiskSpace = function (totalFileSize) {
        var formData = new FormData();
        formData.append("totalFileSize", totalFileSize);
        var url = this.getJobApiUrl("/e5ec7051/check_client_storage_limit");
        return this.http.post(url, formData);
    };
    JobViewService.prototype.linkRecallJob = function (formData) {
        var url = this.getJobApiUrl("link_job");
        return this.http.post(url, formData);
    };
    JobViewService.prototype.recallEvent = function (res) {
        this.recallDetails.next(res);
    };
    JobViewService.prototype.getInvoiceList = function (customerId, jobId, customerType, param, selectedType) {
        if (selectedType === void 0) { selectedType = ''; }
        var url = this.getJobApiUrl(("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/invoices/revenue/" + selectedType + "/view"));
        var invoiceData = this.http.post(url, param).pipe(map(function (response) {
            return {
                data: response.data.invoices || [],
                count: response.count || 0,
                addOnData: response.addOnData
            };
        }));
        return invoiceData;
    };
    /** WIP service pricing catalogue IDs not yet invoiced — for get_pricing_items excludePricingItems when adding a service */
    JobViewService.prototype.getWipExcludePricingItemIds = function (customerType, customerId, jobId) {
        var url = this.getJobApiUrl("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/invoices/wip/services/exclude-pricing-item-ids");
        return this.http.get(url);
    };
    JobViewService.prototype.getPinnedNotesList = function (tablePKId) {
        return this.http.get(this.getJobApiUrl("pinned_notes/" + tablePKId + "/view"));
    };
    JobViewService.prototype.getCostDetails = function (customerId, jobId, customerType) {
        var url = this.getJobApiUrl("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/costs/details");
        return this.http.post(url, '');
    };
    JobViewService.prototype.getInvoiceDetails = function (customerId, jobId, customerType) {
        var url = this.getJobApiUrl("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/invoices/details");
        return this.http.post(url, '');
    };
    JobViewService.prototype.saveCustomColumn = function (screenName, param) {
        var data = { 'columnValue': param, 'screenName': screenName };
        var url = this.getApiUrl("userColumnOrder");
        return this.http.post(url, data);
    };
    JobViewService.prototype.getJobCertificateDetails = function (customerId, jobId, customerType) {
        var url = this.getJobApiUrl("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/job_certificate_details");
        return this.http.post(url, '');
    };
    JobViewService.prototype.customColumn = function (headers, gridConfig) {
        var headerSettings = headers;
        // 1. Filter only active headers
        var activeHeaders = headerSettings.filter(function (h) { return h.active; });
        var updatedColDefs = gridConfig.gridConfig.colDefs.map(function (col) {
            var headerInfo = activeHeaders.find(function (h) { return h.field === col.field; });
            if (headerInfo) {
                return tslib_1.__assign({}, col, { headerName: headerInfo.title || col.headerName, hide: !headerInfo.active || headerInfo.hidden, pos: headerInfo.pos });
            }
            return col;
        });
        // 2. Sort based on pos
        updatedColDefs = updatedColDefs.sort(function (a, b) {
            var posA = a.pos !== undefined ? a.pos : 9999;
            var posB = b.pos !== undefined ? b.pos : 9999;
            return posA - posB;
        });
        // 3. Remove temp pos property (optional)
        updatedColDefs = updatedColDefs.map(function (_a) {
            var pos = _a.pos, rest = tslib_1.__rest(_a, ["pos"]);
            return rest;
        });
        // 4. Assign to gridConfig
        gridConfig.gridConfig.colDefs = updatedColDefs;
    };
    JobViewService.prototype.getPartsList = function (customerType, customerId, jobId, category, partStatus, param) {
        var url = this.getJobApiUrl("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/parts");
        var partData = this.http.post(url, param).pipe(map(function (response) {
            return {
                data: response[category].data || [],
                count: response[category].count || 0,
                addOnData: {
                    active_columns: response[category].active_columns,
                    all_columns: response[category].all_columns,
                    column_formats: response[category].column_formats,
                    statusCount: response[category].statusCount,
                    moduleId: response['moduleId'],
                    jobToDos: response['jobToDos'],
                    groupKeys: param['groupKeys'] || [],
                    groupRowCount: response[category].count || 0,
                    data: response[category].data || [],
                }
            };
        }));
        return partData;
    };
    /**
     * Get part IDs (and minimal row data) for current filters. Used when "Select All" is checked
     * with grouping so one API call can drive Delete, Fulfill, and Mark-as actions.
     */
    JobViewService.prototype.getPartsIds = function (customerType, customerId, jobId, params) {
        var url = this.getJobApiUrl("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/parts/ids");
        var body = tslib_1.__assign({ category: params.category, status: params.status, searchText: params.searchText || '', milestoneval: params.milestoneval != null ? params.milestoneval : null, page: params.page != null ? params.page : 1, limit: params.limit != null ? params.limit : 10 }, params, { rowGroupCols: null, groupKeys: null });
        console.log('[Parts] getPartsIds request: url=', url, 'body=', body);
        return this.http.post(url, body).pipe(map(function (res) {
            var out = {
                partIds: res.partIds || [],
                data: res.data || [],
                count: res.count != null ? res.count : (res.data || []).length,
            };
            console.log('[Parts] getPartsIds response:', { count: out.count, partIdsLength: out.partIds.length, dataLength: out.data.length });
            return out;
        }));
    };
    JobViewService.prototype.getPartsDownloadList = function (customerType, customerId, jobId, param) {
        var url = this.getJobApiUrl("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/job_parts_download");
        return this.http.post(url, param, { responseType: 'blob' });
    };
    JobViewService.prototype.getPartsDetails = function (customerId, jobId, customerType) {
        var url = this.getJobApiUrl("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/parts/details");
        return this.http.post(url, '');
    };
    JobViewService.prototype.addJobPart = function (data, customerType, customerId, jobId) {
        var _this = this;
        var url = this.getApiUrl("customers/" + customerType + "/" + customerId + "/jobs/" + jobId + "/add_new_part");
        var newData = { 'part': data };
        return this.http.post(url, newData).pipe(tap(function () { return _this.triggerFinanceRefresh(jobId); }));
    };
    JobViewService.prototype.getPartDetails = function (jobId, partId) {
        var url = this.getApiUrl('get_part_details') + "/" + jobId;
        var data = { 'partId': partId };
        return this.http.post(url, data);
    };
    JobViewService.prototype.getPricingItems = function () {
        var url = this.getApiUrl("system_settings/pricing_items");
        return this.http.post(url, '');
    };
    JobViewService.prototype.getPartFormDetails = function (customerId, customerType, jobId) {
        var url = this.getApiUrl("customers/" + customerType + "/" + customerId + "/jobs/" + jobId + "/parts/new");
        return this.http.post(url, '');
    };
    JobViewService.prototype.getSupplierPrices = function (partId) {
        var url = this.getApiUrl("parts_and_prices/" + partId + "/supplier_prices");
        var supplierData = this.http.post(url, '').pipe(map(function (response) {
            var processedData = (response.data || []).map(function (item) { return (tslib_1.__assign({}, item, { priceupdatedon: item.priceupdatedon.split(' ')[0] || null })); });
            return {
                data: processedData,
                count: processedData.length
            };
        }));
        return supplierData;
    };
    JobViewService.prototype.saveCreatedPart = function (data) {
        var url = this.getApiUrl("parts_and_prices/add");
        return this.http.post(url, data);
    };
    JobViewService.prototype.getPartKitList = function (partId) {
        var url = "" + this.getApiUrl('getPartKit');
        var params = new HttpParams().set('partId', partId.toString());
        return this.http.get(url, { params: params });
    };
    JobViewService.prototype.savePartKit = function (customerId, customerType, jobId, partData) {
        var _this = this;
        var url = this.getApiUrl("customers/" + customerType + "/" + customerId + "/jobs/" + jobId + "/add_part_kit");
        var data = {
            data: JSON.stringify({
                part_kit: partData.kitId,
                part_kit_quantity: partData.setQuantity,
                part_status: partData.partStatus
            })
        };
        var headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post(url, data, { headers: headers }).pipe(tap(function () { return _this.triggerFinanceRefresh(jobId); }));
    };
    JobViewService.prototype.job_part_batch_status_update = function (jobId, activeTab, status, params) {
        var _this = this;
        if (activeTab == 'requested') {
            activeTab = 'Requested';
        }
        return this.http.post(this.getApiUrl("jobs/" + jobId + "/parts/" + activeTab + "/part_batch_status_update/" + status), params, {
            responseType: 'text'
        }).pipe(tap(function () { return _this.triggerFinanceRefresh(Number(jobId)); }));
    };
    JobViewService.prototype.jobPartPurchaseOrderDetail = function (partId, id, jobId, status) {
        var url = this.getApiUrl('getJobPartViewList');
        var params = new HttpParams()
            .set('partId', partId.toString())
            .set('id', id.toString())
            .set('jobId', jobId.toString())
            .set('status', status);
        return this.http.get(url, { params: params });
    };
    JobViewService.prototype.saveEditPart = function (params) {
        var _this = this;
        var url = this.getApiUrl('edit_part');
        console.log('saveEditPart params', params);
        return this.http.post(url, params).pipe(tap(function () { return _this.triggerFinanceRefresh(_this.getJobIdFromPartPayload(params)); }));
    };
    JobViewService.prototype.getLabourRateBreakup = function (id) {
        var url = this.getJobApiUrl('getLabourRateBreakup/' + id);
        return this.http.get(url);
    };
    JobViewService.prototype.getPartsAvailableStockLocations = function (customerId, customerType, jobId, partsId) {
        var url = this.getJobApiUrl("customers/" + customerType + "/" + customerId + "/jobs/" + jobId + "/list_parts_stock_locations");
        var params = new HttpParams().set('partId', partsId.toString());
        return this.http.get(url, { params: params });
    };
    JobViewService.prototype.getAllStockLocations = function (q) {
        return this.http.get(this.getApiUrl("get_all_stock_locations?q=" + q));
    };
    JobViewService.prototype.saveFulfilSelectedParts = function (data) {
        var _this = this;
        return this.http.post(this.getApiUrl("save_part_fulfill"), data).pipe(tap(function () {
            var payload = data;
            var refreshJobId = payload && (payload.jobId || payload.jobid);
            _this.triggerFinanceRefresh(Number(refreshJobId || undefined));
        }));
    };
    JobViewService.prototype.askAIJobSummary = function (customerId, jobId, customerType, param) {
        var url = this.getJobApiUrl("customers/" + customerType + "/" + customerId + "/job/" + jobId + "/ai-search-job");
        return this.http.post(url, param); //
    };
    JobViewService.prototype.savePricingItem = function (customerId, jobId, customerType, data) {
        var _this = this;
        return this.http.post(this.getApiUrl("customers/" + customerType + "/" + customerId + "/jobs/" + jobId + "/invoice_items/save"), data).pipe(tap(function () { return _this.triggerFinanceRefresh(Number(jobId)); }));
    };
    JobViewService.prototype.addLabourCosts = function (customerId, jobId, customerType, data) {
        var _this = this;
        var body = new URLSearchParams();
        // Set labourtype nested fields
        if (data.labourtype) {
            Object.keys(data.labourtype).forEach(function (key) {
                body.set("labourtype[" + key + "]", data.labourtype[key]);
            });
        }
        // Set other fields
        body.set('labourrate', data.labourrate || '');
        body.set('onsitetimehours', data.onsitetimehours || '0');
        body.set('onsitetimemins', data.onsitetimemins || '0');
        body.set('route', data.route || '');
        body.set('perdiem', data.perdiem || '');
        body.set('mileage', data.mileage || '');
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
            responseType: 'text'
        };
        return this.http.post(this.getApiUrl("customer/" + customerType + "/" + customerId + "/jobs/" + jobId + "/costs/labour/save_labour_cost"), body.toString(), options).pipe(tap(function () { return _this.triggerFinanceRefresh(Number(jobId)); }));
    };
    JobViewService.prototype.saveEditLabour = function (customerId, jobId, customerType, data) {
        var _this = this;
        var body = new URLSearchParams();
        // Set labourtype nested fields
        if (data.labourtype) {
            Object.keys(data.labourtype).forEach(function (key) {
                // Handle objects (like diaryTimeTracking) by stringifying them
                var value = typeof data.labourtype[key] === 'object'
                    ? JSON.stringify(data.labourtype[key])
                    : data.labourtype[key];
                body.set("labourtype[" + key + "]", value !== null && value !== undefined ? value : '');
            });
        }
        if (data.labourItemId !== undefined) {
            body.set('labourItemId', data.labourItemId || '');
        }
        if (data.hasOwnProperty('isConnectedToDiaryEvent')) {
            body.set('isDisconnectedFromDiary', data.isConnectedToDiaryEvent === true ? '0' : '1');
        }
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http.post(this.getApiUrl("customer/" + customerType + "/" + customerId + "/jobs/" + jobId + "/costs/labour/update_labour_cost"), body.toString(), options).pipe(tap(function () { return _this.triggerFinanceRefresh(Number(jobId)); }));
    };
    JobViewService.prototype.getEditLabourDetails = function (customerId, customerType, jobId, labourId, labourItemId) {
        var url = this.getApiUrl("customers/" + customerType + "/" + customerId + "/jobs/" + jobId + "/costs/" + labourId + "/labour_item_details");
        if (labourItemId) {
            url += "?labourItemId=" + labourItemId;
        }
        return this.http.get(url);
    };
    JobViewService.prototype.addTravelCosts = function (customerId, jobId, customerType, data) {
        var _this = this;
        var body = new URLSearchParams();
        body.set('travel[date]', data.date || '');
        body.set('travel[description]', data.description || '');
        body.set('travel[engineerid]', data.engineerid || '');
        body.set('travel[price]', data.price || '');
        body.set('route', 'jobs_v2');
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
            responseType: 'text'
        };
        return this.http.post(this.getApiUrl("customers/" + customerType + "/" + customerId + "/jobs/" + jobId + "/new_travel"), body.toString(), options).pipe(tap(function () { return _this.triggerFinanceRefresh(Number(jobId)); }));
    };
    JobViewService.prototype.updateTravelCosts = function (customerId, jobId, customerType, data) {
        var _this = this;
        var body = new URLSearchParams();
        if (data.travel) {
            Object.keys(data.travel).forEach(function (key) {
                // Handle objects by stringifying them
                var value = typeof data.travel[key] === 'object'
                    ? JSON.stringify(data.travel[key])
                    : data.travel[key];
                body.set("travel[" + key + "]", value || '');
            });
        }
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
            responseType: 'text'
        };
        return this.http.post(this.getApiUrl("update_travel"), body.toString(), options).pipe(tap(function () { return _this.triggerFinanceRefresh(Number(jobId)); }));
    };
    JobViewService.prototype.getEditTravelDetails = function (customerId, jobId, customerType, travelId) {
        return this.http.get(this.getApiUrl("customers/" + customerType + "/" + customerId + "/jobs/" + jobId + "/edit_travel/" + travelId + "/details"));
    };
    JobViewService.prototype.uncompleteJob = function (type, customerId, jobId) {
        var url = this.getJobApiUrl("customers/" + type + "/" + customerId + "/jobs/" + jobId + "/uncomplete");
        return this.http.post(url, '');
    };
    /**
     * Builds the "job already complete" type-to-confirm modal config used to uncomplete
     * a job before continuing an action (add appointment, add part, etc).
     */
    JobViewService.prototype.getUncompleteJobConfirmModalConfig = function (actionLabel, customerType, customerId, jobId, onSuccess) {
        var _this = this;
        return {
            showModal: false,
            modalType: 'confirm',
            title: this.translate.instant('job.uncomplete.confirm.title'),
            actionText: 'in progress',
            confirmBtnText: this.translate.instant('job.uncomplete.confirm.button', { actionLabel: actionLabel }),
            confirmBtnType: 'DEFAULT',
            confirmBxValidationMsg: this.translate.instant('confirmation.warning.text', { word: 'In progress', message: 'continue' }),
            defaultTextMessage: false,
            message: {
                warningTxt: this.translate.instant('job.uncomplete.confirm.warning', { actionLabel: actionLabel }),
                helpTxtList: [this.translate.instant('job.uncomplete.confirm.help', { actionLabel: actionLabel })],
            },
            doAction: function (arg, cb) {
                _this.uncompleteJob(customerType, customerId, jobId).subscribe(function () {
                    cb('SUCCESS');
                    onSuccess();
                }, function (error) {
                    cb('FAILED');
                    console.log('err', error);
                });
            },
        };
    };
    /**
     * Builds the blocking warning modal config shown when a job cannot receive a new
     * diary event/part/etc because it has been aborted, free-of-charge'd, or invoiced.
     */
    JobViewService.prototype.getJobBlockedWarningModalConfig = function (actionLabel, completedReason) {
        return {
            showModal: false,
            modalType: 'warning',
            title: 'Diary job',
            message: {
                warningTxt: "You cannot create diary event for this job because this job has been " + completedReason.toLowerCase(),
            },
        };
    };
    /**
     * Checks live job status before proceeding with an add-record action.
     * If the job is plainly completed, hands the caller a type-to-confirm modal config
     * to uncomplete and proceed. If the job has been aborted/FOC'd/invoiced, hands the
     * caller a blocking warning modal config instead. Otherwise runs onProceed directly.
     */
    JobViewService.prototype.checkJobCompletedBeforeAction = function (jobId, customerType, customerId, actionLabel, onShowModal, onProceed) {
        var _this = this;
        this.timelineService.getJobStatusDetailsNew(jobId).subscribe(function (data) {
            var completedReason = data['completedReason'];
            var jobStatus = data['status'];
            if (completedReason == null && jobStatus === 'completed') {
                onShowModal(_this.getUncompleteJobConfirmModalConfig(actionLabel, customerType, customerId, jobId, onProceed));
            }
            else if (completedReason != null) {
                onShowModal(_this.getJobBlockedWarningModalConfig(actionLabel, completedReason));
            }
            else {
                onProceed();
            }
        });
    };
    JobViewService.prototype.getUserScreenPreference = function (screenName) {
        var url = this.getApiUrl("get_user_screen_preference/" + screenName);
        return this.http.get(url);
    };
    JobViewService.prototype.getJobFilesCustomerPortalAccess = function (type, customerId, jobId) {
        return this.http.get(this.getJobApiUrl("customers/" + type + "/" + customerId + "/job/" + jobId + "/files/customer-portal-access"));
    };
    JobViewService.prototype.getAdminConfiguration = function (type, customerId, jobId) {
        return this.http.get(this.getJobApiUrl("customers/" + type + "/" + customerId + "/job/" + jobId + "/admin/view"));
    };
    JobViewService.prototype.updateCustomerPortalAccess = function (jobId, showOnPortal) {
        var data = {
            jobId: jobId,
            showOnPortal: showOnPortal
        };
        return this.http.post(this.getJobApiUrl('editJobPortalAccess'), data);
    };
    JobViewService.ngInjectableDef = i0.defineInjectable({ factory: function JobViewService_Factory() { return new JobViewService(i0.inject(i1.HttpClient), i0.inject(i2.SidepanelModalService), i0.inject(i3.BsModalRef), i0.inject(i4.Router), i0.inject(i5.TranslateService), i0.inject(i0.NgZone), i0.inject(i6.JobSidebarService), i0.inject(i7.TimelineService)); }, token: JobViewService, providedIn: "root" });
    return JobViewService;
}(InterfaceService));
export { JobViewService };
